import React from 'react';
import logo from '../../assets/logo.PNG';

interface LogoProps {
  maxWidth?: number | string;
}

const Logo: React.FC<LogoProps> = ({ maxWidth = 180 }) => (
  <div style={{ textAlign: 'center', marginBottom: 16, marginTop: 16 }}>
    <img
      src={logo}
      alt="Martin Video Platform Logo"
      style={{ maxWidth, width: '100%', height: 'auto', display: 'inline-block' }}
    />
  </div>
);

export default Logo;
